module.exports = __webpack_public_path__ + "media/LandingPageAssets/charm_tick-491f7038.png";